import { makeStyles } from '@material-ui/core/styles'
import GirlIcon from 'src/assets/Buy_Policy_Images/GirlIcon.svg'
import Addition from 'src/assets/Buy_Policy_Images/Addition.svg'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import BoyIcon from 'src/assets/Buy_Policy_Images/BoyIcon.svg'
import React, { useState } from 'react'
import { MenuItem, Select } from '@mui/material'
import IconButton from '@mui/material/IconButton'
import { Clear } from '@mui/icons-material'
import { addScroll, removeScroll } from 'src/utils/commonMethods'
import { GENDER_TYPE_ENUMS } from 'src/utils/constants/BuyPolicy'

const KidsAgeForm = ({ kidsDetails, handleKidsAgeChange, parentsMinAge }) => {
  const classes = useStyles()
  const [kidsAgeDetails, setKidsAgeDetails] = useState(kidsDetails)
  // Generate an array of numbers from 1 to 100
  const numbers = Array.from({ length: 100 }, (_, index) => index + 1)
  let ageInYears = numbers
  if (parentsMinAge && parentsMinAge - 18 >= 0) {
    ageInYears = numbers?.filter((number) => number < parentsMinAge - 18)
  }

  const handleAddKidDetails = (gender) => {
    setKidsAgeDetails(() => [
      ...kidsAgeDetails,
      {
        id: kidsAgeDetails?.length + 1,
        gender,
        age: '',
      },
    ])
  }

  const handleRemoveKidDetails = (index) => {
    const ageDetailsArray = kidsAgeDetails
    ageDetailsArray?.splice(index, 1)
    setKidsAgeDetails([...ageDetailsArray])
  }

  const getKidIcon = (gender) => {
    return gender === GENDER_TYPE_ENUMS?.MALE ? BoyIcon : GirlIcon
  }

  const getTotalNumberOfKids = (gender) => {
    const filteredKidsArray = kidsAgeDetails?.filter(
      (kidDetails) => kidDetails?.gender === gender
    )
    return filteredKidsArray?.length
  }

  const handleAgeChange = (event, index) => {
    const kidsArray = kidsAgeDetails
    kidsArray[index].age = Number(event?.target?.value)
    setKidsAgeDetails(JSON.parse(JSON.stringify(kidsArray)))
    handleKidsAgeChange(JSON.parse(JSON.stringify(kidsArray)))
  }

  const handleClear = (index) => {
    const kidsArray = kidsAgeDetails
    kidsArray[index].age = ''
    setKidsAgeDetails(JSON.parse(JSON.stringify(kidsArray)))
    handleKidsAgeChange(JSON.parse(JSON.stringify(kidsArray)))
  }

  return (
    <>
      <div className={classes.kidsContainer}>
        {kidsAgeDetails?.map((kidDetails, index) => {
          return (
            <div
              className={classes.ageFormContent}
              key={`kid_${kidDetails?.id}`}
              id='ageFormContent'
            >
              <img
                src={getKidIcon(kidDetails?.gender)}
                className={classes.kidIcon}
                alt={kidDetails?.gender}
              />
              <span
                onClick={() => handleAddKidDetails(kidDetails?.gender)}
                id='addIcon'
              >
                <img src={Addition} className={'cursor-pointer'} alt={'Add'} />
              </span>
              <Select
                id='kidAge'
                name='kidAge'
                className={`form-input ${classes.ageInput}`}
                placeholder={'Select Age'}
                value={kidDetails?.age ?? ''}
                onChange={(event) => handleAgeChange(event, index)}
                displayEmpty
                sx={{
                  '&  .MuiInputBase-root': {
                    height: '0.7rem !important',
                    minHeight: 'unset',
                    width: '100px',
                  },
                  '&  .MuiSelect-select': {
                    minHeight: 'unset',
                    width: '100px',
                  },
                  '& .MuiSelect-iconOutlined': {
                    display: kidDetails?.age ? 'none' : '',
                  },
                }}
                endAdornment={
                  <IconButton
                    id='kidAgeClear'
                    sx={{ display: kidDetails?.age ? '' : 'none' }}
                    className={'clear-button'}
                    onClick={() => handleClear(index)}
                  >
                    <Clear />
                  </IconButton>
                }
                onOpen={() => {
                  removeScroll()
                }}
                onClose={() => {
                  addScroll()
                }}
              >
                <MenuItem value=''>Select Age</MenuItem>
                {ageInYears?.map((number) => (
                  <MenuItem key={number} value={number}>
                    {number}
                  </MenuItem>
                ))}
              </Select>
              {getTotalNumberOfKids(kidDetails?.gender) > 1 && (
                <span
                  onClick={() => handleRemoveKidDetails(index)}
                  id='removeIcon'
                >
                  <DeleteOutlineIcon
                    className={'cursor-pointer'}
                    alt={'Remove'}
                  />
                </span>
              )}
            </div>
          )
        })}
      </div>
    </>
  )
}

export default KidsAgeForm

const useStyles = makeStyles({
  kidsContainer: {
    padding: '19px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: '10px',
  },
  ageFormContent: {
    display: 'flex',
    gap: '10px',
    alignItems: 'center',
  },
  ageInput: {
    width: '140px !important',
    height: '30px',
  },
  kidIcon: {
    height: '35px',
    width: '25px',
  },
})
